import React from 'react';
import ReactDOM from 'react-dom/client';
import './scss/_global.scss';
import Router from './router/index';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router />
);